import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  linkLabel?: string;
  linkTo?: string;
}

export default function SectionHeading({ eyebrow, title, description, linkLabel, linkTo }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <p className="mb-1.5 flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-accent-700">
            <span className="inline-block h-[6px] w-[6px] rounded-full bg-accent-500" />
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-xl font-semibold text-foreground-950 md:text-2xl">{title}</h2>
        {description && <p className="mt-2 max-w-[620px] text-[13px] leading-6 text-foreground-500">{description}</p>}
      </div>
      {linkLabel && linkTo && (
        <Link
          to={linkTo}
          className="group inline-flex shrink-0 items-center gap-1 text-[13px] text-foreground-600 transition-colors hover:text-primary-700"
        >
          {linkLabel}
          <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-0.5">
            <i className="ri-arrow-right-line text-sm" />
          </span>
        </Link>
      )}
    </div>
  );
}